<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/user-management.vue'
import axios from 'axios'
import { httpServices } from '@utils/http-services'
import { colorArr } from '@utils/style.const'
import { hasErrors } from '@utils/form'

export default {
  page: {
    title: 'Group Profile',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      hasErrors,
      group: null,
      users: null,
      show: false,
      colors: colorArr.sort(),
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    }
  },
  mounted() {
    httpServices.getGroup(this.$route.params.groupId).then((res) => {
      this.group = res
      this.$nextTick(() => {
        this.form.validateFields()
      })
    })
    httpServices.getUsers().then((res) => {
      this.users = res
    })
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.group.meta = {
            ...values,
            orgId: this.$auth.user.profile.permissions.organization,
          }

          axios
            .put(
              process.env.VUE_APP_KONSUL_API_URL + '/permissions/groups',
              this.group,
              {
                headers: {
                  Authorization: 'Bearer ' + this.$auth.user.access_token,
                },
              }
            )
            .then(
              (res) => {
                this.$notification.success({
                  message: `${
                    res?.data?.meta?.name || 'Group'
                  } Successfully Updated`,
                })
                this.$router.push({
                  name: 'user-management',
                })
              },
              () => {
                this.$notification.error({
                  message: 'Failed to Update Group',
                })
              }
            )
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="ant-row profile--container">
      <div class="breadcrumb--container">
        <a-breadcrumb>
          <a-breadcrumb-item href="#">
            <router-link to="/">
              <a-icon type="home" />
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="#">
            <router-link to="/user-management">
              <a-icon type="team" />
              <span>User Management</span>
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <a-icon type="profile" />
            Group Profile
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="form-container">
        <div
          class="header"
          style="
            padding: 1.2rem;
            margin-bottom: 0;
            text-align: center;
            background: #141414;
            border-radius: 4px 4px 0 0;
          "
        >
          <h4 style="margin: 0; font-weight: 100; color: #fff">
            <a-icon type="profile" style="padding-right: 4px" />
            Group Profile &middot; {{ this.$route.params.groupId }}
          </h4>
        </div>

        <template v-if="group">
          <a-form :form="form" @submit="handleSubmit">
            <a-card>
              <a-tabs default-active-key="1">
                <a-tab-pane key="1" tab="Group Meta Data">
                  <a-card style="width: 100%">
                    <a-row>
                      <a-col :sm="16" :md="6">
                        <a-form-item label="Name">
                          <a-input
                            v-decorator="[
                              'name',
                              {
                                initialValue: $route.params.groupId,
                                rules: [
                                  {
                                    required: true,
                                    placeholder:
                                      'Please input your group name!',
                                  },
                                ],
                              },
                            ]"
                            :placeholder="this.$route.params.groupId"
                          />
                        </a-form-item>
                      </a-col>
                      <a-col :sm="16" :md="6">
                        <a-form-item label="Color">
                          <a-select
                            v-decorator="[
                              'color',
                              {
                                required: true,
                                initialValue: group.meta.color,
                              },
                            ]"
                          >
                            <a-select-option
                              v-for="(c, i) in colors"
                              :key="i"
                              :value="c.toLowerCase()"
                            >
                              {{ c }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                      <a-col :sm="16" :md="12">
                        <a-form-item label="Users">
                          <a-select
                            v-decorator="[
                              'userId',
                              {
                                initialValue: group.meta.userId,
                              },
                            ]"
                            mode="multiple"
                          >
                            <a-select-option
                              v-for="user in users"
                              :key="user.key"
                              :value="user.pk"
                            >
                              {{ user.pk.replace('USER#', '') }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>
                    </a-row>
                  </a-card>
                </a-tab-pane>
              </a-tabs>

              <a-row class="submit--container">
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button
                      type="primary"
                      html-type="submit"
                      :disabled="hasErrors(form.getFieldsError())"
                    >
                      Save
                    </a-button>
                  </a-form-item>
                </a-col>
                <a-col :sm="16" :md="8">
                  <a-form-item>
                    <a-button @click="$router.go(-1)"> Cancel </a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-card>
          </a-form>
        </template>
        <template v-else>
          <div class="loader--container">
            <a-icon
              type="loading"
              style="padding-left: 4px; font-size: 24px; color: #1890ff"
              spin
            />
          </div>
        </template>
      </div>
    </div>
  </Layout>
</template>
